import styled from "styled-components";

export const CvActionsFooterWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  button {
    margin: 0 2.5px;
  }
`;

export const DownloadCvButton = styled.button`
  font-weight: bold;
  color: #f2008c;
  background: transparent;
  border: 1px solid #f2008c;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  padding: 10px 12px;
  font-family: Raleway;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  transition: 0.15s ease-in-out;

  &:hover {
    cursor: pointer;
    color: "#fff";
    background: "#bc006d";
    border: 1px solid #f2008c;
  }

  &:active,
  &:visited {
    cursor: pointer;
    color: #fff;
    background: #673490;
    border: 1px solid #673490;
    outline: none;
  }

  &[disabled] {
    border: 1px solid grey;
    background: transparent;
    color: grey;
    cursor: no-drop;
  }

  &:focus {
    background: "#673490";
    border: "1px solid #673490";
    outline: none;
  }
`;
